import workflowTypes from './types';

// Fetch Admin levels
export const fetchWorkflows = () => ({
  type: workflowTypes.FETCH_WORKFLOWS_REQUEST,
  payload: null,
});
export const fetchWorkflowsSuccess = (payload) => ({
  type: workflowTypes.FETCH_WORKFLOWS_SUCCESS,
  payload,
});
export const fetchWorkflowsFailure = (payload) => ({
  type: workflowTypes.FETCH_WORKFLOWS_FAILURE,
  payload,
});
